import { customField } from '@libs/domain';
import { customFieldAttribute } from '@libs/enums';
import {
  CheckboxInFieldBody,
  FieldHead,
  FormField,
  InputNumberInFieldBody,
  InputStringInFieldBody,
  SelectWithEnum,
} from '@ps-smart-cp/ppfw-client';
import { customFieldBasicSettingFieldConfig } from '../item-config';
import type { CustomFieldBasicSetting } from '../models';

interface CustomFieldBasicSettingRowProps {
  setting: CustomFieldBasicSetting;
  setSetting: (setting: CustomFieldBasicSetting) => void;
  errorFields?: string[];
}

// TODO: カスタムフィールド設定のstyled-component対応(https://proship-infra.atlassian.net/browse/AFW-326)
function CustomFieldBasicSettingRow(props: CustomFieldBasicSettingRowProps) {
  const { setting, errorFields, setSetting } = props;
  const row = setting.customFieldKey + 1;

  return (
    <div style={{ display: 'contents' }}>
      <div style={{ gridArea: `${row}/1`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <FieldHead
            itemName={
              customField.names[
                `customField0${setting.customFieldKey.toString()}` as keyof typeof customField.names
              ]
            }
          />
        </FormField>
      </div>
      <div style={{ gridArea: `${row}/2`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <CheckboxInFieldBody
            id={`custom-field-is-used-${setting.customFieldKey - 1}`}
            obj={setting}
            setObj={setSetting}
            prop="isUsed"
            transparentBorder
            labelName=""
            errorFields={errorFields}
          />
        </FormField>
      </div>
      <div style={{ gridArea: `${row}/3`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <InputStringInFieldBody
            id={`custom-field-display-name-${setting.customFieldKey - 1}`}
            obj={setting}
            setObj={setSetting}
            prop="displayName"
            itemAttribute={customFieldBasicSettingFieldConfig.displayName.attribute}
            errorFields={errorFields}
            disabled={!setting.isUsed}
          />
        </FormField>
      </div>
      <div style={{ gridArea: `${row}/4`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <SelectWithEnum
            id={`custom-field-attribute-${setting.customFieldKey - 1}`}
            obj={setting}
            setObj={setSetting}
            prop="attribute"
            enumType={customFieldAttribute.enum}
            enumNameConfig={customFieldAttribute.nameConfig}
            errorFields={errorFields}
            except={['date', 'fullWidth', 'halfWidth', 'realNumber', 'ym']}
            disabled={!setting.isUsed}
          />
        </FormField>
      </div>
      <div style={{ gridArea: `${row}/5`, display: 'flex', justifyContent: 'center' }}>
        <FormField>
          <InputNumberInFieldBody
            id={`custom-field-code-digits-${setting.customFieldKey - 1}`}
            obj={setting}
            setObj={setSetting}
            prop="codeDigits"
            itemAttribute={customFieldBasicSettingFieldConfig.codeDigits.attribute}
            errorFields={errorFields}
            disabled={
              (setting.attribute !== '2' && setting.attribute !== customFieldAttribute.enum.mstCode) ||
              !setting.isUsed
            }
          />
        </FormField>
      </div>
    </div>
  );
}

export { CustomFieldBasicSettingRow };
export type { CustomFieldBasicSettingRowProps };
